<div class="tw-flex tw-items-center tw-justify-between section-download-patient-template"  @fadeInAnimation> <!--*ngIf="loadPanel && !user.patients"-->
  <div > <!--*ngIf="expert?.defaultPDFWorkerTemplateId"-->
    <p class="text-info">Si lo deseas puedes descargar la plantilla con los datos del paciente</p>
    <button nz-button nzType="primary" class="tw-mt-3 download-patient-template" (click)="onDownloadPdfTemplate()">Descargar</button>
  </div>
  <!--<div >--> <!--*ngIf="!expert?.defaultPDFWorkerTemplateId"-->
    <!--<p class="text-info">No se ha seleccionado una plantilla para los datos del paciente</p>-->
    <!--<button nz-button nzType="default" class="btn-default tw-mt-3">Seleccionar</button>--><!-- [routerLink]="'/clinic/' + clinicId + '/profile/expert/me/templates'" [queryParams]="{page: 1}"-->
 <!-- </div>-->
<!--  <img loading="lazy" style="max-height: 150px;" [src]="'../../../../assets/images/' + (expert?.defaultPDFWorkerTemplateId ? '4537623.jpg' : 'listen.jpg')" alt="">-->
  <img loading="lazy" style="max-height: 150px;" [src]="'../../../../assets/images/4537623.jpg'" alt="">
</div>
